import { varsFromServer } from './client_side_injection_vars';

function getActiveExperiments(experimentsString = varsFromServer.experimentsString) {
  if (!experimentsString) return {};

  const experimentsArray = experimentsString.split(';');
  return experimentsArray.reduce((acc, eachExperimentAssignment) => {
    let [experimentKey, experimentValue] = eachExperimentAssignment.split('=');
    acc[experimentKey.trim()] = experimentValue;
    return acc;
  }, {});
}

export function getExperimentValue(key, experimentsString) {
  return getActiveExperiments(experimentsString)[key];
}

export function isExperimentActive(key, experimentsString) {
  return Boolean(getActiveExperiments(experimentsString)[key]);
}
